import {
    CLEAR_IMAGES,
    IMAGE,
    IMAGE_ERROR,
    IMAGE_SUCCESS
} from '../constants/imagesConstants';


const url='https://pixabay.com/api/'

const apiKey='27840132-5aa3e1c9a512f21d3759c20e7'


function getImages(data) {
    return {
        type: IMAGE,
        data
    }
};

function getImagesSuccess(data) {
    return {
        type: IMAGE_SUCCESS,
        data
    }
};

function getImagesError(data) {
    return {
        type: IMAGE_ERROR,
        data
    }
};

export function GetPixabyImages(input, page=1) {
    return async (dispatch) => {
        dispatch(getImages());

        const response = await fetch(`${url}?key=${apiKey}&q=${input.replace(' ', '+')}&image_type=photo&min_width=500&min_height=500&safesearch=true&per_page=20&page=${page}`);
    
        const data = await response.json();

        let images = []

        if(response.status===200){

            images=data.hits.map(i=>({id:i.id,url:i.webformatURL, thumbnail:i.previewURL}))
            
            dispatch(getImagesSuccess({images:images, total: data.total, search:input}))


        }else{
            dispatch(getImagesError(data))
        }
    
        return {images:images, total:data.total};
        
    }
};

export const ClearImages=()=>({type:CLEAR_IMAGES})